<ul class="nav nav-tabs justify-content-start">

  <li
    *ngIf="hasRole(TipoUsuario.OPERADOR, TipoUsuario.SUPERVISOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.OPERADOR_3, TipoUsuario.OPERADORDIRECTO, TipoUsuario.TUTOR, TipoUsuario.RESPRODUCTO, TipoUsuario.MANDATARIO, TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_AV, TipoUsuario.COMERCIAL_LN, TipoUsuario.SOPORTE)"
    class="nav-item"><a class="nav-link" class="nav-link" routerLink="pedidos" routerLinkActive="active">Pedidos</a>
  </li>
  <li
    *ngIf="hasRole(TipoUsuario.OPERADOR, TipoUsuario.SUPERVISOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.OPERADOR_3, TipoUsuario.OPERADORDIRECTO, TipoUsuario.TUTOR, TipoUsuario.RESPRODUCTO, TipoUsuario.MANDATARIO, TipoUsuario.SOPORTE)"
    class="nav-item"><a class="nav-link" class="nav-link" routerLink="remitoCargamento" routerLinkActive="active">Remito
      Cargamento</a>
  </li>

</ul>

<router-outlet></router-outlet>